import gsap from "gsap";

export class Barker extends HTMLElement {
	constructor() {
		super();

        this.init();
    }
    init() {
        window.addEventListener("DOMContentLoaded", () => {
            // Alert removed
            const tl = gsap.timeline();

            tl.to(".account-button", { backgroundColor: "black", duration: 1 });
            tl.to(".account-button", { backgroundColor: "white", duration: 1 });
        });
    }
}